import { useEffect, useRef } from "react";

const reduce = () => typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const FlowImage = ({ src, alt, fade = "soft", speed = 0.06, className = "", imgClassName = "", testid }) => {
  const wrap = useRef(null);
  const img = useRef(null);
  useEffect(() => {
    if (reduce()) return undefined;
    let raf = 0;
    const tick = () => {
      raf = 0;
      const el = wrap.current;
      if (!el || !img.current) return;
      const r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      const y = (r.top + r.height / 2 - window.innerHeight / 2) * -speed;
      img.current.style.transform = `translate3d(0, ${y.toFixed(1)}px, 0) scale(1.1)`;
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(tick); };
    tick();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => { window.removeEventListener("scroll", onScroll); window.removeEventListener("resize", onScroll); cancelAnimationFrame(raf); };
  }, [speed]);
  return (
    <div ref={wrap} data-testid={testid} className={`flow-${fade} overflow-hidden ${className}`}>
      <img ref={img} src={src} alt={alt} loading="lazy" className={`h-full w-full scale-110 object-cover will-change-transform ${imgClassName}`} />
    </div>
  );
};
